export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_EDUCATION":
      return [...state, action.payload.education];
    case "UPDATE_EDUCATIONS":
      return action.payload.educations;
    case "DELETE_EDUCATION":
      return state.filter((education) => {
        return education.id !== action.payload.education.id
      });
    default:
      return state;
  }
}
